<template>
  <div class="qh-container">
    <!-- 头部 -->
    <div class="qh-header">
      <!-- <img class="qh-logo" :src="pageAttr[curIndex].src" alt=""> -->
      <div class="qh-header-child">
        <div>
          <img class="qh-logo" :src="pageAttr[curIndex].src" alt="">
          <img class="qh-logo-2" :src="pageAttr2[curIndex].src" alt="">
        </div>
        <div class="qh-title-box" :style="{color: pageAttr[curIndex].color }">
          <div class="qh-title-item" @click="setActive(0)">奇点</div>
          <div class="qh-title-item" @click="setActive(1)">瞬息</div>
          <div class="qh-title-item" @click="setActive(2)">万物科学说明书</div>
          <div class="qh-title-item" @click="setActive(3)">商务合作</div>
        </div>
      </div>
    </div>
    <!-- <el-carousel
      height="100vh"
      direction="vertical"
      :autoplay="false"
      :loop="false"
      @change="sliderChange"
      indicator-position=""
      ref="carousel"
    > -->
      <full-page :options="options" ref="page">
      <!-- 第一屏 -->
      <!-- <el-carousel-item> -->
        <div class="qh-screen bg-red section">
          <div class="qh-modal box1">
            <div class="qh-modal-l">
              <div :class="['qh-text-1 color-fff', curIndex === 0 && 'translate_1']">奇点网</div>
              <div :class="['qh-text-2 color-f2f5f8', curIndex === 0 && 'translate_2']">让学术变得流行</div>
              <div :class="['qh-text-3 color-f2f5f8', curIndex === 0 && 'translate_3']">奇点网持续关注全球范围内的医疗科技创新，致力于让中国医生便捷、及时、准确地捕捉医学进展。奇点网强大的深度原创内容生产能力，让无数艰深晦涩的研究变成通俗易懂的爆款文章，是创新医疗领域有突出影响力的媒体之一。</div>
              <div class="qb-f-r">
                <img :class="['qh-qr-code', curIndex === 0 && 'translate_3']" src="https://static-s.geekheal.net/qd-home/static/images/qrcode_qd.jpg" alt="">
                <div :class="['qh-text-3 color-f2f5f8', curIndex === 0 && 'translate_3']">扫描二维码 即刻关注</div>
              </div>
            </div>
            <div class="qh-modal-r" :class="[curIndex === 0 && 'qh-modal-r-trans']">
              <div class="qh-bg-img-box" :class="[curIndex === 0 && 'qh-bg-img-box-trans']">
                <img class="qh-bg-img-2" src="https://static-s.geekheal.net/qd-home/static/images/GS.svg" alt="">
                <img class="qh-bg-img-1" src="https://static-s.geekheal.net/qd-home/static/images/GL.svg" alt="">
              </div>
              <img :class="['qh-phone-img right-220', curIndex === 0 && 'on-phone-left qh-phone-img-trans']" src="https://static-s.geekheal.net/qd-home/static/images/11.png" alt="">
            </div>
          </div>
        </div>
      <!-- </el-carousel-item> -->
      <!-- 第二屏 -->
      <!-- <el-carousel-item> -->
        <div class="qh-screen bg-white section">
          <div class="qh-modal box2">
            <div class="qh-modal-l">
              <div :class="['qh-text-1 color-1480FF', curIndex === 1 && 'translate_1']">瞬息</div>
              <div :class="['qh-text-2 color-1480FF', curIndex === 1 && 'translate_2']"><span>为中国医生量身定制的</span><span>循证医学每日精选</span></div>
              <div :class="['qh-text-3 color-1480FF', curIndex === 1 && 'translate_3']">同步全球3000+医学学术期刊，随时捕捉医学学术前沿动态。每天10分钟，即可获得超越同行的学术视野。更有pubmed镜像搜索，随时随地搜你所需。</div>
              <img :class="['qh-qr-code', curIndex === 1 && 'translate_3']" src="https://static-s.geekheal.net/qd-home/static/images/qrcode_sx.jpg" alt="">
              <div :class="['qh-text-3 color-1480FF', curIndex === 1 && 'translate_3']">扫描二维码</div>
              <div :class="['qh-text-3 color-1480FF', curIndex === 1 && 'translate_3']">瞬息之间捕捉万变</div>
            </div>
            <div class="qh-modal-r" :class="[curIndex === 1 && 'qh-modal-r-trans']">
              <div class="qh-bg-img-box" :class="[curIndex === 1 && 'qh-bg-img-box-trans']">
                <img class="qh-bg-img-3" src="https://static-s.geekheal.net/qd-home/static/images/SS.svg" alt="">
                <img class="qh-bg-img-4" src="https://static-s.geekheal.net/qd-home/static/images/SL.svg" alt="">
              </div>
              <img :class="['qh-phone-img right-220', curIndex === 1 && 'on-phone-right qh-phone-img-trans']" src="https://static-s.geekheal.net/qd-home/static/images/S2.png" alt="">
            </div>
          </div>
        </div>
      <!-- </el-carousel-item> -->
      <!-- 第三屏 -->
      <!-- <el-carousel-item> -->
        <div class="qh-screen bg-black section">
          <div class="qh-modal box3">
            <div class="qh-modal-3-l">
              <div :class="['qh-text-1 color-fff', curIndex === 2 && 'translate_1']">万物科学说明书</div>
              <div :class="['qh-text-2 color-f2f5f8', curIndex === 2 && 'translate_2']">探究万物真相的死理性派</div>
              <!-- <div :class="['qh-text-3 color-f2f5f8', curIndex === 2 && 'translate_3']">我们不打算讨好读者，也没有太多热情逗哏，但我<br/>们的确是有种热情：希望在纷繁复杂的世界里，为<br/>你展现科学的理性思维之美。</div> -->
              <div :class="['qh-text-3 color-f2f5f8', curIndex === 2 && 'translate_3']"><span>我们不打算讨好读者，也没有太多热情逗哏，但我</span><span>们的确是有种热情：希望在纷繁复杂的世界里，为</span><span>你展现科学的理性思维之美。</span></div>
              <img :class="['qh-qr-code', curIndex === 2 && 'translate_3']" src="https://static-s.geekheal.net/qd-home/static/images/qrcode_ww.jpg" alt="">
              <div :class="['qh-text-3 color-f2f5f8', curIndex === 2 && 'translate_3']">扫描二维码 即刻关注</div>
            </div>
            <div class="qh-modal-r" :class="[curIndex === 2 && 'qh-modal-r-trans']">
              <div class="qh-bg-img-box" :class="[curIndex === 2 && 'qh-bg-img-box-trans']">
                <img class="qh-bg-img-5" src="https://static-s.geekheal.net/qd-home/static/images/WS.svg" alt="">
                <img class="qh-bg-img-6" src="https://static-s.geekheal.net/qd-home/static/images/WL.svg" alt="">
              </div>
              <img :class="['qh-phone-img right-220', curIndex === 2 && 'on-phone-right qh-phone-img-trans']" src="https://static-s.geekheal.net/qd-home/static/images/22.png" alt="">
            </div>
          </div>
        </div>
      <!-- </el-carousel-item> -->
      <!-- 第四屏 -->
      <!-- <el-carousel-item> -->
        <div class="qh-screen bg-white section">
          <div class="qh-modal box4">
            <div class="qh-modal-3-l">
                <div :class="['qh-text-1 color-1D1E22 margin', curIndex === 3 && 'translate_1']">商务合作</div>
                <div :class="['qh-text-4 color-1D1E22', curIndex === 3 && 'translate_2']"><span>联系我们</span></div>
                <div :class="['qh-text-4 color-1D1E22 m-t-35', curIndex === 3 && 'translate_2']">商务合作：</div>
                <!-- <div :class="['qh-text-4 color-1D1E22', curIndex === 3 && 'translate_2']"><span>电话：</span>18601016915</div>
                <div :class="['qh-text-4 color-1D1E22', curIndex === 3 && 'translate_2']"><span>邮箱：</span>chenyaping@geekheal.com</div> -->
                <div :class="['qh-text-4 color-1D1E22', curIndex === 3 && 'translate_2']"><span>电话：</span>13051538360</div>
                <div :class="['qh-text-4 color-1D1E22', curIndex === 3 && 'translate_2']"><span>邮箱：</span>zhangjinli@geekheal.com</div>
                <div :class="['qh-text-4 color-1D1E22 m-t-35', curIndex === 3 && 'translate_2']"><span>与主编切磋：</span></div>
                <div :class="['qh-text-4 color-1D1E22', curIndex === 3 && 'translate_2']"><span>微信：</span>geekheal_candy</div>
            </div>
            <img class="qh-bg-img-7 m-t-58" :class="[curIndex === 3 && 'qh-modal-r-trans']" src="https://static-s.geekheal.net/qd-home/static/images/B.svg" alt="">
          </div>
          <div class="copyright"><a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">京ICP备15029832号-1</a></div>
        </div>
      <!-- </el-carousel-item> -->
    <!-- </el-carousel> -->
    </full-page>
    <ul class="point-box">
      <li
      v-for="item in [0, 1, 2, 3]"
      :key="item"
      :class="['point-item', item === curIndex && 'point-item-active']"
      :style="{background: pageAttr2[curIndex].color, opacity: item === curIndex ? 1 : 0.3}"
       @click="setActive(item)"
    ></li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data () {
    return {
      pageAttr: [
        { src: 'https://static-s.geekheal.net/qd-home/static/images/logo-white.svg', color: '#fff' },
        { src: 'https://static-s.geekheal.net/qd-home/static/images/logo-blue.svg', color: '#1480FF' },
        { src: 'https://static-s.geekheal.net/qd-home/static/images/logo-white.svg', color: '#fff' },
        { src: 'https://static-s.geekheal.net/qd-home/static/images/logo-color.png', color: '#1D1E22' }
      ],
      pageAttr2: [
        { src: 'https://static-s.geekheal.net/qd-home/static/images/logo.svg', color: 'rgb(255,255,255)' },
        { src: 'https://static-s.geekheal.net/qd-home/static/images/logo 2.svg', color: 'rgb(155,155,155)' },
        { src: 'https://static-s.geekheal.net/qd-home/static/images/logo.svg', color: 'rgb(255,255,255)' },
        { src: 'https://static-s.geekheal.net/qd-home/static/images/logo 3.svg', color: 'rgb(155,155,155)' }
      ],
      curIndex: 0,
      firstRender: true,
      options: {

        //           //为每个section设置背景色
        //           sectionsColor: ["#f00","#0f0","#00f"],
        // //用来控制slide幻灯片的箭头，设置为false，两侧的箭头会消失
        //           controlArrows: false,
        // //每一页幻灯片的内容是否垂直居中
        //           verticalCentered: false,
        // //字体是否随着窗口缩放而缩放
        //           resize: true,
        // //页面滚动速度
        //           scrollingSpeed: 700,
        // //定义锚链接，用户可以快速打开定位到某一页面；不需要加"#"，不要和页面中任意的id和name相同
        //           anchors: ["page1","page2","page3"],
        // //是否锁定锚链接
        //           lockAnchors: true,
        // //定义section页面的滚动方式，需要引入jquery.easings插件
        //           easing:,
        // //是否使用css3 transform来实现滚动效果
        //           css3: false,
        // //滚动到最顶部后是否连续滚动到底部
        //           loopTop: true,
        // //滚动到最底部后是否连续滚动到顶部
        //           loopBottom: true,
        // //横向slide幻灯片是否循环滚动
        //           loopHorizontal: false,
        // //是否循环滚动，不会出现跳动，效果很平滑
        //           continuousVertical: true,
        // //是否使用插件滚动方式，设为false后，会出现浏览器自带的滚动条，将不会按页滚动
        //           autoScrolling: false,
        // //是否包含滚动条，设为true，则浏览器自带的滚动条会出现，页面还是按页滚动，但是浏览器滚动条默认行为也有效
        //           scrollBar: true,
        // //设置每个section顶部的padding，当我们要设置一个固定在顶部的菜单、导航、元素等时使用
        //           paddingTop: "100px",
        // //设置每个section底部的padding，当我们要设置一个固定在底部的菜单、导航、元素等时使用
        //           paddingBottom: "100px",
        // //固定的元素，为jquery选择器；可用于顶部导航等
        //           fixedElements: ".nav",
        // //是否可以使用键盘方向键导航
        //           keyboardScrolling: false,
        // //在移动设置中页面敏感性，最大为100，越大越难滑动
        //           touchSensitivity: 5,
        // //设为false，则通过锚链接定位到某个页面不再有动画效果
        //           animateAnchor: false,
        // //是否记录历史，可以通过浏览器的前进后退来导航
        //           recordHistory: true,
        // //绑定菜单，设定相关属性和anchors的值对应后，菜单可以控制幻灯片滚动
        //           menu: '.nav',
        // //是否显示导航，设为true会显示小圆点作为导航
        //           navigation: true,
        // //导航小圆点的位置，可以设置为left或者right
        //           navigationPosition: right,
        // //鼠标移动到小圆点上时显示出的提示信息
        //           navigationTooltips: ["第一页","第二页","第三页"],
        // //是否显示当前页面小圆点导航的提示信息，不需要鼠标移上
        //           showActiveTooltip: true,
        // //是否显示横向幻灯片的导航
        //           slidesNavigation: true,
        // //横向幻灯片导航的位置，可以为top或者bottom
        //           slidesNavPosition: bottom,
        // //内容超过满屏时是否显示滚动条，需要jquery.slimscroll插件
        //           scrollOverflow: true,
        // //section选择器
        //           sectionSelector: ".section",
        // //slide选择器
        //           slideSelector: ".slide"
        paddingTop: '121px',
        scrollingSpeed: 600,
        resize: true,
        licenseKey: null,
        css3: true,
        // afterLoad: this.afterLoad,
        onLeave: this.onLeave,
        scrollOverflow: true,
        navigation: true, // 是否显示导航，默认为false
        navigationPosition: 'right', // 导航小圆点的位置
        scrollBar: false,
        // touchSensitivity: 70,
        keyboardScrolling: false // 是否可以使用键盘方向键导航，默认为true
        // continuousVertical: false, /// 是否循环滚动，默认为false。如果设置为true，则页面会循环滚动，而不像loopTop或loopBottom那样出现跳动，注意这个属性和loopTop、loopBottom不兼容和，不要同时设置
        // menu: '#menu'
        // navigation: true,
        // anchors: ['page1', 'page2', 'page3'],
        // sectionsColor: ['#41b883', '#ff5f45', '#0798ec', '#fec401', '#1bcee6', '#ee1a59', '#2c3e4f', '#ba5be9', '#b4b8ab']
      }
    }
  },
  methods: {
    afterLoad (anchors, item) {
      // console.log(anchors, item, 'eeeee')
      // if (this.firstRender) {
      //   this.firstRender = false
      // } else {
      //   this.curIndex = item.index
      // }
    },
    onLeave (anchors, item) {
      console.log(anchors, item, 'beffff')
      this.curIndex = item.index
      // if (this.firstRender) {
      //   this.firstRender = false
      // } else {
      //   this.curIndex = item.index
      // }
    },
    after (anchors, item) {
      if (this.firstRender) {
        this.firstRender = false
      } else {
        this.curIndex = item.index
      }
    },
    sliderChange (index) {
      this.curIndex = index
    },
    setActive (index) {
      // this.$refs.carousel.setActiveItem(index)
      this.$refs.page.api.moveTo(index + 1, index)
      this.curIndex = index
    }
  },
  mounted () {
    // window.addEventListener('Mousewheel', this.scrollHandle) // 绑定页面的滚动事件
    if (document.body.clientWidth < 480) {
      this.options.paddingTop = '80px'
    }
  }
}
</script>

<style lang="scss" scoped>
  .qh-container{
    // overflow: hidden;
    // height: 100vh;
  }
  .color-fff{
    color: #fff;
  }
  .color-f2f5f8{
    color: #f2f5f8;
  }
  .color-1480FF{
    color: #1480FF;
  }
  .color-1D1E22{
    color: #1D1E22;
  }
  .bg-red{
    background: #e3364a;
  }
  .bg-white{
    background: #ffffff;
  }
  .bg-black{
    background: #1D1E22;
  }
  .m-t-35{
    margin-top: 35px;
  }
  .m-t-58{
    margin-top: 58px;
  }
  @media (min-width: 480px) {
    // .point-box {
    //   display: none;
    // }
    .point-box {
      position: fixed;
      height: 100vh;
      top: 0;
      right: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      z-index: 9999;
    }
    .point-item{
      list-style: none;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-bottom: 10px;
      opacity: 0.3;
      transition: background .3s linear;
      cursor: pointer;
    }
    .qh-header{
      height: 121px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 64px;
      box-sizing: border-box;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
    }
    .qh-header-child{
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 1140px;
    }
    .qh-logo{
      width: 153px;
      height: 45px;
    }
    .qh-logo-2{
      display: none;
    }
    .qh-title-box{
      display: flex;
      justify-content: center;
    }
    .qh-title-item{
      font-size: 18px;
      font-weight: 600;
      margin-right: 49px;
      transition: all .3s linear;
      cursor: pointer;
    }
    .qh-screen{
      width: 100vw;
      height: 100vh;
      padding-top: 121px;
      box-sizing: border-box;
      overflow: hidden;
      .copyright{
        position: fixed;
        bottom: 50px;
        text-align: center;
        left: 50%;
        width: 300px;
        margin-left: -150px;
        a{
          color: #1480FF;
          text-decoration: none;
        }
      }
    }
    .qh-modal{
      display: flex;
      justify-content: space-between;
      padding: 71px 64px 0;
      overflow: hidden;
      height: calc(100vh - 192px);
      // height: 100%;
      // max-width: 1480px;
      max-width: 1140px;
      margin: 0 auto;
    }
    .qh-modal-l{
      // padding-left: 64px;
      flex-shrink: 0;
      max-width: 367px;
      width: 34%;
      margin-top: 34px;
      position: relative;
      z-index: 999;
      // overflow: hidden;
    }
    .qh-modal-3-l{
      // padding-left: 64px;
      flex-shrink: 0;
      margin-top: 34px;
      // overflow: hidden;
    }
    .qh-text-1{
      font-size: 60px;
      // font-family: SourceHanSansSC-Heavy,SourceHanSansSC;
      font-weight: 800;
      line-height: 89px;
      margin-bottom: 4px;
      opacity: 0;
    }
    .qh-text-2{
      font-size: 18px;
      font-weight: 600;
      line-height: 25px;
      margin-bottom: 8px;
      opacity: 0;
    }
    .qh-text-3{
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      text-align: justify;
      opacity: 0;
      span{
        display: block;
      }
    }
    .qh-text-4{
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      text-align: justify;
      opacity: 0;
    }
    .qh-qr-code{
      display: block;
      width: 150px;
      height: 150px;
      background: rgba(216,216,216,1);
      margin: 21px 0 11px;
      opacity: 0;
      border: none;
    }
    @keyframes translate_l {
      0%{
        opacity: 0;
      }
      100%{
        left: 0;
        opacity: 1;
      }
    }
    .translate_1{
      position: relative;
      left: -200px;
      animation: translate_l .3s ease-in-out forwards .2s;
    }
    .translate_2{
      position: relative;
      left: -200px;
      animation: translate_l .3s ease-in-out forwards .4s;
    }
    .translate_3{
      position: relative;
      left: -200px;
      animation: translate_l .3s ease-in-out forwards .6s;
    }
    @keyframes scale_1 {
      0%{
        opacity: 0;
        transform: scale(.7);
      }
      50%{
        opacity: 1;
        transform: scale(1);
      }
      100%{
        opacity: 1;
        transform: scale(1);
      }
    }
    .qh-modal-r{
      flex-shrink: 0;
      position: relative;
      left: -25px;
      opacity: 0;
    }
    .qh-modal-r-trans{
      transform: scale(.7);
      animation: scale_1 .7s ease-in-out forwards .2s;
    }
     @keyframes transparent_1 {
      0%{
        opacity: 1;
      }
      100%{
        opacity: .4;
      }
    }
    .qh-bg-img-box{
      opacity: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .qh-bg-img-box-trans{
      animation: transparent_1 .3s ease-in-out forwards .7s;
    }
    .qh-bg-img-1{
      width: 600px;
      height: 435px;
      margin-top: 114px;
    }
    .qh-bg-img-2{
      position: absolute;
      z-index: 2;
      width: 215px;
      left: -75px;
      height: 217px;
      // position: absolute;
      // bottom: 0;
      // right: 0;
    }
    .qh-bg-img-3{
      width: 174px;
      height: 174px;
      position: absolute;
      top: -16px;
      left: -50px;
    }
    .qh-bg-img-4{
      width: 500px;
      height: 464px;
      margin-top: 60px;
    }
    .qh-bg-img-5{
      width: 222px;
      height: 179px;
      position: absolute;
      top: 88px;
      left: -60px;
    }
    .qh-bg-img-6{
      width: 505px;
      height: 516px;
    }
    .qh-bg-img-7{
      width: 687px;
      height: 370px;
      margin-top: 120px;
      margin-right: 80px;
      opacity: 0;
    }
    @keyframes toTop {
      0%{
        top: 500px;
        opacity: 0;
      }
      100%{
        top: -75px;
        opacity: 1;
      }
    }
    .qh-phone-img{
      position: absolute;
      width: 930px;
      z-index: 3;
    }
    .qh-phone-img-trans{
      top: 500px;
      opacity: 0;
      animation: toTop .5s ease-in-out forwards .7s;
    }
    .left-71{
      left: -71px;
    }
    .left-200{
      left: -200px;
    }
    .right-220{
      right: -220px;
    }
  }
  @media (max-width: 480px) {
     .point-box {
      position: fixed;
      top: 20px;
      right: 20px;
      display: flex;
      flex-direction: column;
      z-index: 9999;
    }
    .point-item{
      list-style: none;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-bottom: 10px;
      opacity: 0.3;
      transition: background .3s linear;
    }
    .qh-header{
      // height: 65px;
      height: 80px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      box-sizing: border-box;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
    }
    .qh-logo{
      display: none;
    }
    .qh-logo-2{
      width: 54px;
      height: 40px;
    }
    .qh-title-box{
      display: none;
    }
    .qh-screen{
      width: 100vw;
      height: 100vh;
      padding-top: 65px;
      box-sizing: border-box;
      overflow: hidden;
    }
    .qh-modal{
      height: 100%;
      overflow: hidden;
    }
    .qh-modal-l{
      padding: 0 15px;
      overflow: hidden;
    }
    .qh-modal-3-l{
      padding: 0 15px;
      overflow: hidden;
    }
    .qh-modal-r{
      position: relative;
    }
    .qh-text-1{
      font-size: 30px;
      margin-top: 30px;
      // font-family: SourceHanSansSC-Heavy,SourceHanSansSC;
      font-weight: 800;
      // line-height: 89px;
      margin-bottom: 15px;
      opacity: 0;
    }
    .qh-text-2{
      font-size: 21px;
      font-weight: 600;
      line-height: 25px;
      margin-bottom: 10px;
      opacity: 0;
      span{
        display: block;
      }
    }
    .qh-text-3{
      font-size: 14px;
      font-weight: 400;
      line-height: 19px;
      text-align: justify;
      opacity: 0;
    }
    .qh-text-4{
      font-size: 18px;
      color: #1d1e22;
      line-height: 25px;
      text-align: justify;
      opacity: 0;
      span{
        font-weight: 600;
      }
    }
    .qh-qr-code{
      display: block;
      width: 150px;
      height: 150px;
      background: rgba(216,216,216,1);
      margin: 21px 0 11px;
      opacity: 0;
      border: none;
    }
    @keyframes translate_l {
      0%{
        opacity: 0;
      }
      100%{
        left: 0;
        opacity: 1;
      }
    }
    .translate_1{
      position: relative;
      left: -200px;
      animation: translate_l .3s ease-in-out forwards .1s;
    }
    .translate_2{
      position: relative;
      left: -200px;
      animation: translate_l .3s ease-in-out forwards .3s;
    }
    .translate_3{
      position: relative;
      left: -200px;
      animation: translate_l .3s ease-in-out forwards .5s;
    }
    .qb-f-r{
      float: right;
    }
    .qh-bg-img-1{
      width: 100%;
      margin-top: 50px;
    }
    .qh-bg-img-2{
      position: absolute;
      width: 150px;
      top: -180px;
      left: 15px;
    }
    .qh-bg-img-3{
      position: absolute;
      width: 150px;
      top: -200px;
      right: 15px;
    }
    .qh-bg-img-4{
      width: 100%;
      // margin-top: 50px;
    }
    .qh-bg-img-5{
      position: absolute;
      width: 160px;
      top: -160px;
      right: 15px;
    }
    .qh-bg-img-6{
      width: 100%;
      position: relative;
      left: -94px;
      top: 25px;
    }
    .qh-bg-img-7{
      height: 207px;
      position: relative;
      right: -20px;
    }
    @keyframes leftTo{
      0% {
        left: -800px;
        opacity: 1;
      }
      100% {
        left: -335px;
        opacity: 1;
      }
    }
    @keyframes rightTo{
      0% {
        right: -800px;
        opacity: 1;
      }
      100% {
        right: -335px;
        opacity: 1;
      }
    }
    .qh-phone-img{
      width: 740px;
      position: absolute;
      top: -250px;
      opacity: 0;
    }
    .on-phone-left{
      // position: absolute;
      left: -800px;
      animation: leftTo .3s ease-in-out forwards .8s;
    }
    .on-phone-right{
      // position: absolute;
      right: -800px;
      animation: rightTo .3s ease-in-out forwards .8s;
    }

    @media (max-width: 321px) {
      @keyframes leftTo{
        0% {
          left: -800px;
          opacity: 1;
        }
        100% {
          left: -335px;
          opacity: 1;
        }
      }
      @keyframes rightTo{
        0% {
          right: -800px;
          opacity: 1;
        }
        100% {
          right: -335px;
          opacity: 1;
        }
      }
      .qh-phone-img{
        width: 740px;
        position: absolute;
        top: -250px;
        opacity: 0;
      }
      .on-phone-left{
        // position: absolute;
        left: -200px !important;
        // animation: leftTo .7s ease-in forwards 1.3s;
      }
      .on-phone-right{
        // position: absolute;
        right: -800px;
        // animation: rightTo .7s ease-in forwards 1.3s;
      }
    }
  }
</style>
